import { render, staticRenderFns } from "./AccessorialTable.vue?vue&type=template&id=4d2d5633&scoped=true"
import script from "./AccessorialTable.vue?vue&type=script&lang=js"
export * from "./AccessorialTable.vue?vue&type=script&lang=js"
import style0 from "./AccessorialTable.vue?vue&type=style&index=0&id=4d2d5633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2d5633",
  null
  
)

export default component.exports